import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";
import wa from "../assets/image/wa-svg.svg";
import fb from "../assets/image/fb-svg.svg";
import x from "../assets/image/x-svg.svg";
import li from "../assets/image/li-svg.svg";
import ig from "../assets/image/ig-svg.svg";

function SearchProfile() {
  const { id } = useParams();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const getInitials = (name) => {
    if (!name) return "A";
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  const getAvatarUrl = (avatar) => {
    if (!avatar) return null;

    if (avatar.startsWith("http")) {
      if (
        avatar.includes("storage/https://") ||
        avatar.includes("storage/http://")
      ) {
        console.log("🔧 Fixing corrupted avatar URL:", avatar);
        const match = avatar.match(/storage\/(https?:\/\/.+)$/);
        if (match && match[1]) {
          console.log("✅ Cleaned URL:", match[1]);
          return match[1];
        }
      }
      return avatar;
    }

    if (avatar.startsWith("data:")) return avatar;

    const cleanedPath = avatar.replace(/^\/+/, "");
    return `${cleanedPath}`;
  };

  useEffect(() => {
    const fetchUser = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;
        const res = await fetch(`${TEST_BASE_URL}/users/${id}`, {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });

        const data = await res.json();
        if (res.ok) {
          setUser(data.data);
        } else {
          console.error("Failed to fetch user:", data);
        }
      } catch (err) {
        console.error("Error fetching user:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  if (loading) return <p>Loading profile...</p>;
  if (!user) return <p>User not found.</p>;

  const avatarUrl = getAvatarUrl(user.avatar);

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content bg-white">
        <TopBar onToggleSidebar={toggleSidebar} />
        <div className="profile">
          <div className="myprofilebg">
            <p>Member Profile</p>

            <div
              style={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                overflow: "hidden",
                background: "#0045e8",
                color: "white",
                fontWeight: "bold",
                fontSize: "42px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              {avatarUrl && !imageError ? (
                <img
                  src={avatarUrl}
                  alt={user.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  onError={() => setImageError(true)}
                />
              ) : (
                getInitials(user.name)
              )}
            </div>
          </div>

          <div className="myprofile-content">
            <div className="name-edit">
              <div>
                <h6>{user.name || "n/a"}</h6>
                <span>
                  <small>{user.profession || "n/a"}</small>
                </span>
                <br />
                <span>
                  <small>{user.location || "n/a"}</small>
                </span>
                <br />
                <span>
                  <small>{user.email || "n/a"}</small>
                </span>
                <br />
                <span>
                  <small>{user.phone_number || "n/a"}</small>
                </span>
              </div>
            </div>

            <hr className="hr" />

            <div>
              <div className="name-edit">
                <h6>Other Information</h6>
              </div>
              <div className="row profileditrow">
                <div className="col-md-4">
                  <div>
                    <h6 className="py-2">Bio</h6>
                    <p>{user.bio || "No bio provided"}</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div>
                    <h6 className="py-2">Short Testimony</h6>
                    <p>{user.short_testimony || "No testimony provided"}</p>
                  </div>
                </div>
              </div>
            </div>

            <hr className="hr" />

            <div>
              <div className="name-edit">
                <h6>Social Media Links</h6>
              </div>

              <div className="social-row mt-4">
                {user.whatsapp_url ? (
                  <a href={user.whatsapp_url} className="whatsapp">
                    <img src={wa} alt="" />
                    Connect on WhatsApp
                  </a>
                ) : (
                  <p className="text-secondary">No WhatsApp connected</p>
                )}

                {user.instagram_url ? (
                  <a href={user.instagram_url} className="instagram">
                    <img src={ig} alt="" />
                    Connect on Instagram
                  </a>
                ) : (
                  <p className="text-secondary">No Instagram connected</p>
                )}

                {user.facebook_url ? (
                  <a href={user.facebook_url} className="facebook">
                    <img src={fb} alt="" />
                    Connect on Facebook
                  </a>
                ) : (
                  <p className="text-secondary">No Facebook connected</p>
                )}
              </div>

              <div className="social-row mt-4">
                {user.x_url ? (
                  <a href={user.x_url} className="twitter">
                    <img src={x} alt="" />
                    Connect on X (Twitter)
                  </a>
                ) : (
                  <p className="text-secondary">No X (Twitter) connected</p>
                )}

                {user.linkedin_url ? (
                  <a href={user.linkedin_url} className="linkedin">
                    <img src={li} alt="" />
                    Connect on LinkedIn
                  </a>
                ) : (
                  <p className="text-secondary">No LinkedIn connected</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SearchProfile;
